import { useCallback, useRef } from 'react'

interface LatestRequest {
  beginLatestRequest: () => number
  cancelPendingRequests: () => void
  isLatestRequest: (requestId?: number) => boolean
}

export function useLatestRequest(): LatestRequest {
  const latestRequestIdRef = useRef(0)

  const beginLatestRequest = useCallback(() => {
    latestRequestIdRef.current += 1

    return latestRequestIdRef.current
  }, [])

  const cancelPendingRequests = useCallback(() => {
    latestRequestIdRef.current += 1
  }, [])

  const isLatestRequest = useCallback((requestId?: number) => {
    return latestRequestIdRef.current === requestId
  }, [])

  return {
    beginLatestRequest,
    cancelPendingRequests,
    isLatestRequest,
  }
}
